<template>
    <inv-link-resolver
        v-if="transactionLine && transactionLine.invoiceUuid && transactionLine.subAccountUuid"
        :uuid="transactionLine.invoiceUuid"
        :invoice-no="transactionLine.invoiceNo"
        :sub-account-uuid="transactionLine.subAccountUuid"
    />
</template>

<script setup lang="ts">

import {TransactionLine} from '@/types/transaction/TransactionLine'
import {computed, provide} from 'vue'
import InvLinkResolver from '@/textTokenizer/InvLinkResolver.vue'

const props = defineProps({
    params: {
        type: Object as () => {
            data: TransactionLine,
            context: any
        },
        required: true
    }
})

provide('panelId', props.params?.context.panelId)
provide('panelPathSegment', props.params?.context.panelPathSegment)

const transactionLine = computed(() => {
    return props.params?.data
})
</script>

<style scoped>

</style>